import type { WelcomePage as WelcomePageData } from '@ellie/shared';

interface WelcomePageProps {
  welcomePage: WelcomePageData;
}

/**
 * Renders the personalized welcome page between cover and TOC.
 * Greets the learner, summarizes workbook contents, and includes
 * a motivating statistic about personalized learning.
 */
export function WelcomePage({ welcomePage }: WelcomePageProps) {
  return (
    <div className="wb-page wb-welcome">
      <div className="wb-welcome-greeting">{welcomePage.greeting}</div>
      <div className="wb-welcome-summary">{welcomePage.summary}</div>
      <div className="wb-welcome-statistic">
        <span className="wb-welcome-statistic-icon">{'\u{1F4CA}'}</span>
        <p>{welcomePage.statistic}</p>
      </div>
      <span className="wb-page-number">2</span>
    </div>
  );
}
